export const mobileOrLandlinePattern = "^\\+\\d{11}$";

export const namePattern = "^[a-zA-Z-' ]*$";
